import MainProvider from '../providers/main.provider';


export default function App(): JSX.Element {
	return (
		<div className="app">
			<MainProvider/>
		</div>
	);
}